module.exports = __webpack_public_path__ + "media/images/DigitalReports-c8ce5c4c2de72d26c2cf7162bf08b811.svg";